import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../../../api/api";

const AsrsLink = () => {
  const { patientid, filename } = useParams();
  const [loading, setLoading] = useState(true);
  const [json, setJson] = useState(null);

  const practiseid = window.getPracticeId();
  const SCREENSHOT_TARGET_ID = "screenshot-ready-container";

  useEffect(() => {
    const fetchHtml = async () => {
      try {
        const response = await api.get(
          `/v1/${practiseid}/pcard/${patientid}/formHistory/${filename}`
        );
        if (response.status === 200) setJson(response.data?.json_data || null);
      } catch (err) {
        console.log(err);
      } finally {
        setTimeout(() => setLoading(false), 300);
      }
    };

    fetchHtml();
  }, [filename]);

  if (loading)
    return (
      <div className="flex items-center justify-center h-screen text-xl font-semibold">
        Loading...
      </div>
    );

  if (!json)
    return (
      <div className="flex items-center justify-center h-screen text-xl text-red-600">
        No Data Found
      </div>
    );

  // ----------------------------------------------------------------------------------

  const questions = [
    { q: "How often do you have trouble wrapping up the final details of a project, once the challenging parts have been done?", key: "qanswer_3_2" },
    { q: "How often do you have difficulty getting things in order when you have to do a task that requires organization?", key: "qanswer_3_3" },
    { q: "How often do you have problems remembering appointments or obligations?", key: "qanswer_3_4" },
    { q: "When you have a task that requires a lot of thought, how often do you avoid or delay getting started?", key: "qanswer_3_5" },
    { q: "How often do you fidget or squirm with your hands or feet when you have to sit down for a long time?", key: "qanswer_3_6" },
    { q: "How often do you feel overly active and compelled to do things, like you were driven by a motor?", key: "qanswer_3_7" },
    { q: "How often do you make careless mistakes when you have to work on a boring or difficult project?", key: "qanswer_3_8" },
    { q: "How often do you have difficulty keeping your attention when you are doing boring or repetitive work?", key: "qanswer_3_9" },
    { q: "How often do you have difficulty concentrating on what people say to you, even when they are speaking to you directly?", key: "qanswer_3_10" },
    { q: "How often do you misplace or have difficulty finding things at home or at work?", key: "qanswer_3_11" },
    { q: "How often are you distracted by activity or noise around you?", key: "qanswer_3_12" },
    { q: "How often do you leave your seat in meetings or other situations where you’re expected to remain seated?", key: "qanswer_3_13" },
    { q: "How often do you feel restless or fidgety?", key: "qanswer_3_14" },
    { q: "How often do you have difficulty unwinding and relaxing when you have time to yourself?", key: "qanswer_3_15" },
    { q: "How often do you find yourself talking too much in social situations?", key: "qanswer_3_16" },
    { q: "How often do you finish people’s sentences before they can finish?", key: "qanswer_3_17" },
    { q: "How often do you have difficulty waiting your turn in situations requiring turn-taking?", key: "qanswer_3_18" },
    { q: "How often do you interrupt others when they are busy?", key: "qanswer_3_19" },
  ];

  const options = ["Never", "Rarely", "Sometimes", "Often", "Very Often"];

  // ----------------------------------------------------------------------------------

  return (
    <>
      {/* Hidden element for backend screenshot detection */}
     

      <div id={json.patient_name?SCREENSHOT_TARGET_ID:undefined} className="min-h-screen bg-[#f7f7f7] flex justify-center py-10 px-3">
        <div className="bg-white text-start shadow-lg rounded-lg p-6 max-w-4xl w-full">

          {/* Header */}
          <h2 className="text-2xl font-bold mb-4">{json.form_name}</h2>

          {/* Intro */}
          <div className="mb-6">
            <p className="font-bold text-lg mb-2">
              Adult ADHD Self Report Scale (ASRS-v1.1) Symptom Checklist
            </p>
            <p className="text-gray-700">
              Please answer the questions below, rating yourself based on your behavior over the past 6 months.
              Select the answer that best describes how you felt. Discuss this checklist with your healthcare provider.
            </p>
          </div>

          {/* Patient Info */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            <div>
              <label className="font-bold text-base">Patient Name</label>
              <p>{json.patient_name}</p>
            </div>
            <div>
              <label className="font-bold text-base">Date</label>
              <p>{json.cdate}</p>
            </div>
          </div>

          {/* Questions */}
          {questions.map((q, idx) => (
            <div key={idx} className="mb-4">
              <label className="font-bold text-base">{q.q}</label>
              <div className="flex flex-wrap gap-3 mt-2">
                {options.map((opt) => (
                  <span
                    key={opt}
                    className={`px-3 py-1 rounded-full text-sm font-sans border ${
                      json[q.key] === opt
                        ? "bg-blue-600 text-white border-blue-600"
                        : "bg-white border-gray-300 text-black"
                    }`}
                  >
                    {opt}
                  </span>
                ))}
              </div>
            </div>
          ))}

        </div>
      </div>
    </>
  );
};

export default AsrsLink;
